import { useScrollReveal } from '../../../hooks/useScrollReveal';

export function About() {
  const leftRef = useScrollReveal();
  const rightRef = useScrollReveal();

  return (
    <section id="sobre" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div ref={leftRef} className="relative scroll-reveal-left">
            <div className="absolute -top-6 -left-6 w-full h-full bg-gradient-to-br from-amber-200/20 to-amber-100/20 rounded-2xl"></div>
            <div className="relative bg-gradient-to-br from-gray-900 to-black rounded-2xl p-12 shadow-2xl border border-amber-200/20">
              <div className="absolute top-0 right-0 w-32 h-32 bg-amber-200/10 rounded-full filter blur-3xl"></div>
              <i className="ri-speed-fill text-6xl text-amber-200 mb-6"></i>
              <h3 className="text-3xl font-bold text-white mb-4">Velocidade que Gera Resultados</h3>
              <p className="text-gray-300 text-lg leading-relaxed">
                Como um guepardo em ação, combinamos agilidade estratégica com precisão cirúrgica para acelerar o crescimento do seu negócio no ambiente digital.
              </p>
            </div>
          </div>

          <div ref={rightRef} className="scroll-reveal-right">
            <div className="mb-8">
              <h2 className="text-5xl font-black text-white mb-4">Sobre Nós</h2>
              <div className="w-24 h-1 bg-gradient-to-r from-amber-200 to-amber-100"></div>
            </div>

            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>
                Somos a <strong className="text-amber-200">GUEPARDO AGÊNCIA</strong>, uma consultoria de marketing estratégico de alta performance com atuação no Brasil, Estados Unidos (Nova York e Orlando), Itália, Austrália e diversos outros países. Somos veteranos no mercado há 15 anos, transformando ideias em negócios de sucesso e construindo marcas fortes e relevantes.
              </p>
              <p>
                Nascemos com a missão de impulsionar empresas no digital e no físico, utilizando toda a nossa expertise para gerar resultados reais, mensuráveis e sustentáveis.
              </p>
              <p>
                Mais do que uma agência, somos um <strong className="text-amber-200">hub completo de soluções em marketing</strong>, conectando marcas ao público certo com criatividade, autoridade e foco absoluto em desempenho. Nossa agilidade na execução e precisão estratégica nos colocam em destaque no mercado.
              </p>
              <p>
                Nosso portfólio de clientes inclui <strong className="text-amber-200">cantores, jogadores de futebol, influencers, artistas de novela e famosos do Brasil</strong>, além de empresas de diversos segmentos que confiam em nosso trabalho para fortalecer suas marcas.
              </p>
              <p className="font-semibold text-amber-200 text-xl">
                Na GUEPARDO, entregamos muito além de visibilidade: entregamos crescimento sólido, acelerado e consistente.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}